import { render } from "./ViewResults.vue?vue&type=template&id=8bf8911e&scoped=true"
import script from "./ViewResults.vue?vue&type=script&lang=js"
export * from "./ViewResults.vue?vue&type=script&lang=js"

import "./ViewResults.vue?vue&type=style&index=0&id=8bf8911e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf8911e"]])

export default __exports__